import { render, staticRenderFns } from "./EditKategoriSOSPopUp.vue?vue&type=template&id=0d1ed3c3&scoped=true"
import script from "./EditKategoriSOSPopUp.vue?vue&type=script&lang=js"
export * from "./EditKategoriSOSPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditKategoriSOSPopUp.vue?vue&type=style&index=0&id=0d1ed3c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ed3c3",
  null
  
)

export default component.exports